var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('el-image',{style:(`width:${_vm.width};height:${_vm.height};`),attrs:{"src":_vm.src,"fit":_vm.type,"preview-src-list":_vm.srcList},on:{"click":_vm.handleClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }